import clsx from 'clsx';
import { useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import BtnLogin from 'components/BtnLogin';

import { IQueryParams, ITrackEventProps } from 'typescriptDefs';

import { GetKOHOBtn } from '../GetKOHOBtn';
import { LocaleContext } from '../Layout';
import { LocaleSwitch } from './LocaleSwitch';

export const LoginAndRegistration = ({
  buttonLocation,
  darkBg,
  pageIsMultilingual,
  pageLocation,
  queryParams,
  isOverrideNav = false,
  trackEventProps,
}: {
  buttonLocation: string;
  darkBg: boolean;
  pageIsMultilingual?: boolean;
  pageLocation?: any;
  queryParams: IQueryParams;
  isOverrideNav?: boolean;
  trackEventProps: ITrackEventProps;
}) => {
  const locale = useContext(LocaleContext);

  return (
    <div className="flex items-center">
      {isOverrideNav && pageIsMultilingual && pageLocation ? (
        <LocaleSwitch darkBg={darkBg} location={pageLocation} pageIsMultilingual={pageIsMultilingual} />
      ) : (
        <BtnLogin
          buttonLocation="Navbar"
          className={twMerge(
            clsx('mr-16 lg:mr-8', darkBg && 'text-white hover:text-white focus:text-white active:text-white'),
          )}
          trackEventProps={trackEventProps}
        />
      )}
      <GetKOHOBtn
        buttonSize="sm"
        buttonClassName="px-16 py-10"
        buttonVariant={darkBg ? 'primaryInverse' : 'primaryLight'}
        buttonLocation={buttonLocation}
        queryParams={queryParams}
        trackEventProps={trackEventProps}
      >
        {{ en: 'Get KOHO', fr: 'Obtenir KOHO' }[locale]}
      </GetKOHOBtn>
    </div>
  );
};
